// Files ride along with the registration as separate multipart parts named
// `file|<member index>|<field name>`; the backend stores them and fills the
// URLs in. `|` is the separator because field names are free text and can
// contain _ and -.
const splitMemberFiles = (members) => {
    const files = [];
    const stripped = members.map((member, index) => {
        const rest = {};
        for (const [field, value] of Object.entries(member)) {
            if (value instanceof File) {
                files.push([`file|${index}|${field}`, value]);
            } else {
                rest[field] = value;
            }
        }
        return rest;
    });
    return { members: stripped, files };
};

export default splitMemberFiles;
